module.exports = __webpack_public_path__ + "media/images/favicon_32x32-cddad88381469f6c6f9707e010f9db66.png";